// src/tracker/components/AddAccountDialog.js

import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useNotification } from '../../context/NotificationContext'; // <-- Import the hook

const AddAccountDialog = ({ open, onClose, onSuccess, accountToEdit }) => {
    const { showNotification } = useNotification(); // <-- Use the hook
    const phpSymbol = '₱';
    const [name, setName] = useState('');
    const [type, setType] = useState('Bank Account');
    const [balance, setBalance] = useState('');
    const [currency, setCurrency] = useState('PHP');

    useEffect(() => {
        if (open) {
            if (accountToEdit) {
                setName(accountToEdit.name);
                setType(accountToEdit.type);
                setBalance(accountToEdit.balance.toString());
                setCurrency(accountToEdit.currency || 'PHP');
            } else {
                setName('');
                setType('Bank Account');
                setBalance('');
                setCurrency('PHP');
            }
        }
    }, [accountToEdit, open]);

    const handleSubmit = async () => {
        if (!name || !balance || !type || !currency) {
            showNotification('Please fill out all fields', 'warning'); // <-- New Notification
            return;
        }
        const accountData = { name, type, balance: parseFloat(balance), currency };
        const isEditing = accountToEdit !== null;
        const url = isEditing ? `https://frek.cc/proxy/38.54.86.24:8001/api/accounts/${accountToEdit._id}` : 'https://frek.cc/proxy/38.54.86.24:8001/api/accounts';
        const method = isEditing ? 'PUT' : 'POST';

        try {
            const response = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(accountData) });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail || 'Something went wrong');
            }
            showNotification(`Account '${name}' saved successfully!`, 'success'); // <-- New Notification
            onSuccess();
        } catch (error) {
            console.error('Error submitting form:', error);
            showNotification(`Error: ${error.message}`, 'error'); // <-- New Notification
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle>{accountToEdit ? 'Edit Account' : 'Add New Account'}</DialogTitle>
            <DialogContent>
                <TextField autoFocus margin="dense" label="Account Name" type="text" fullWidth variant="outlined" value={name} onChange={e => setName(e.target.value)} />
                <FormControl fullWidth margin="dense">
                    <InputLabel>Account Type</InputLabel>
                    <Select value={type} label="Account Type" onChange={e => setType(e.target.value)}>
                        <MenuItem value="Bank Account">Bank Account</MenuItem>
                        <MenuItem value="E-Wallet">E-Wallet</MenuItem>
                        <MenuItem value="Cash">Cash</MenuItem>
                        <MenuItem value="Investments">Investments</MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="dense">
                    <InputLabel>Currency</InputLabel>
                    <Select value={currency} label="Currency" onChange={e => setCurrency(e.target.value)} disabled={!!accountToEdit}>
                        <MenuItem value="PHP">PHP ({phpSymbol})</MenuItem>
                        <MenuItem value="USD">USD ($)</MenuItem>
                    </Select>
                </FormControl>
                <TextField margin="dense" label="Current Balance" type="number" fullWidth variant="outlined" value={balance} onChange={e => setBalance(e.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddAccountDialog;
